var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.258133 10.9443L0.25629 13.7568L3.06879 13.7587L11.3692 5.46911L8.55857 2.65477L0.258133 10.9443ZM2.44727 12.2583L1.75727 12.2578L1.75772 11.5678L8.55718 4.77727L9.24672 5.46772L2.44727 12.2583ZM13.5463 2.23804L11.7925 0.48189C11.6426 0.331792 11.4551 0.264169 11.2601 0.264041C11.0651 0.263913 10.8776 0.33879 10.735 0.481197L9.36159 1.8528L12.1722 4.66714L13.5456 3.29554C13.8383 3.00323 13.8386 2.53073 13.5463 2.23804V2.23804Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.7820224772b665cfde4b834577ab6062.svg";
export { ForwardRef as ReactComponent };